import styled from 'styled-components';

export const DefaultTitle = styled.span`
  font-size: ${({ theme }) => theme.fonts.fontSize['2xl']};
  font-weight: 700;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.white};
`;
